/* eslint-disable react/prop-types */
import PT from 'prop-types';

// mui imports
import { Box, styled, Typography, Chip, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const BoxCont = styled(Box)(({ theme }) => {
  const { functions } = theme;

  const { pxToRem } = functions;

  return {
    height: 'auto',
    backgroundColor: '#e0e5ec',
    padding: pxToRem(15),
    borderRadius: '25px',
    boxShadow: '0.3rem 0.3rem 0.5rem #6b6868, -0.2rem -0.2rem 0.4rem #fff',
    margin: '2%',
    marginRight: '5%',
    marginLeft: '5%'
  };
});

const TypingContainer = props => {
const [hasSubmitted, setHasSubmitted] = useState(false);
// SJK: CKey-99
  const [keyTriggered, setKeyTriggered] = useState(false);
  useEffect(() => {
  const handler = e => {
    if (
      (e.key === 'Tab' || e.key === 'Enter')      
    ) {
      setKeyTriggered(true);
    }
  };

  document.addEventListener('keydown', handler, true);
  return () => document.removeEventListener('keydown', handler, true);
}, []);
  useEffect(() => {
    if (props.text && props.title.includes('Timing')) {
      if (props.counter === 60) {
        setHasSubmitted(false);
      }
    }
    const continueTimer = !props.isSentencetiming && props.counter < props.TimeLimit;
    // SJK : CKey-99: Carry forward keyTriggered, isSentencetiming
    if (
      (props.text && props.type) ||
      (props.text && props.title && props.title.includes('Timing')) ||
      continueTimer || keyTriggered
    ) {
      let TimeOutCounter;

      if (props.counter === 60) {
        setHasSubmitted(false);
      }
      if (
        (((props.text.length > 0 || continueTimer) &&
        (props.type === 'Timing' || props.title.includes('Timing')) &&
        !props.CounterFlag) || keyTriggered)
      ) {
        if (props.counter > 0 && !props.result) {
          TimeOutCounter = setTimeout(() => props.setCounter(props.counter - 1), 1000);
          props.setCounterTimeoutRefs(prev => [TimeOutCounter, ...prev]);
        }
        if (hasSubmitted) return; // Prevent duplicate submission
        if (props.counter === 0 && Number(props?.attributes?.TimeLimit) > 0) {
          setHasSubmitted(true);
          props.updateResult();
        }
      }

      if (props.automaticSubmit) {
        clearTimeout(TimeOutCounter);
      }
    }
    if (props.text) {
      if (props.text.length > 0 && props.type === 'Timings') {
        setTimeout(() => {
          props.setAutomaticSubmit(true);
        }, Number(props.TimeLimit) * 1000);
      }
    }
  }, [props.counter, props.text, props.automaticSubmit, props.CounterFlag, props.isSentencetiming, keyTriggered]);

  useEffect(() => {
    if (props.TimeLimit) {
      props.setCounter(() => (props.TimeLimit ? Number(props.TimeLimit) : 15));
    }
  }, [props.TimeLimit]);

  let activityTypeAr = ['Document', 'Timing', 'TimingKeypadTab', 'TimingKeypadEnter'];
  let showGoal = activityTypeAr.includes(props?.attributes?.Type);
  return (
    <BoxCont as="section">
      {/* Content Section Below */}
      <Grid container>
        {/* Left Section - Title */}
        <Grid align="left" item xs={8}>
          <Typography variant="sh5">
            {props.title.trim() === 'undefined' ? 'No Data Found' : props.title}
          </Typography>
        </Grid>

        {/* Right Section - Goals, Info Icon, WPM, and Errors */}
        {showGoal || !props.title.includes('Practice') || !props.title.includes('Timing') ? (
          <Grid
            item
            xs={4}
            sx={{
              display: 'flex',
              backgroundColor: 'white !important', // Ensure the background is white
              padding: 2,
              borderRadius: 4, // Rounded edges
              boxShadow: `5px 5px 15px rgba(0, 0, 0, 0.1), -5px -5px 15px rgba(255, 255, 255, 0.5)`, // Neomorphic effect
              maxWidth: '60%', // Reduced width to make it smaller
              marginLeft: 'auto' // Align to the right of the container
            }}>
            {/* Left Side - Goals, Info Icon, WPM, and Errors */}
            {showGoal && (
              <Grid item xs={6} display="flex" flexDirection="column" alignItems="flex-start">
                {/* Goals with Info Icon */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  width="100%"
                  mb={1}>
                  <Typography variant="h6" fontWeight="bold" fontSize="1.5rem">
                    Goals
                  </Typography>
                  <Tooltip title="Goals Information">
                    <IconButton size="small">
                      <InfoIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* WPM and Errors */}
                <Grid container direction="row" justifyContent="center" spacing={4}>
                  {/* WPM Section */}
                  <Grid item>
                    <Typography variant="h6" fontWeight="bold" fontSize="1.5rem" textAlign="center">
                      WPM
                    </Typography>
                    <Typography
                      variant="h6"
                      color="black"
                      fontWeight="bold"
                      fontSize="1.5rem"
                      textAlign="center">
                      {props?.attributes?.WAMGoal}
                    </Typography>
                  </Grid>
                  {/* Errors Section */}
                  <Grid item>
                    <Typography variant="h6" fontWeight="bold" fontSize="1.5rem" textAlign="center">
                      Errors
                    </Typography>
                    <Typography
                      variant="h6"
                      color="black"
                      fontWeight="bold"
                      fontSize="1.5rem"
                      textAlign="center">
                      {props?.attributes?.ErrorGoal}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {/* Vertical Divider */}
            {showGoal && (
              <Grid item xs={1} sx={{ borderLeft: '4px solid #ddd', height: '100%', mx: 1 }} />
            )}
            {/* Increased width */}
            {/* Right Side - Timer and Chip */}
            <Grid
              item
              xs={2} // Adjusted width for the right section
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="flex-start">
              {/* Time Remaining Section */}
              {(props.type === 'Timing' || props.title.includes('Timing')) &&
                props.title.includes('Timing') && (
                  <Box display="flex" flexDirection="column" alignItems="flex-start">
                    {/* Time Remaining */}
                    <Typography
                      variant="h6"
                      color="text.secondary"
                      mr={1}
                      sx={{
                        fontSize: '1.5rem', // Increase font size
                        fontWeight: 'bold' // Make the text bold
                      }}>
                      Time Remaining:
                    </Typography>
                    {/* Timer and "sec" on one line */}
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-around"
                      width="100%"
                      p={2}
                      sx={{
                        borderRadius: '8px'
                      }}>
                      <div>
                        <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                          <Typography
                            variant="h6"
                            color="black"
                            fontWeight="bold"
                            fontSize="1.5rem"
                            sx={{ marginRight: '4px' }}>
                            {props.counter}
                          </Typography>
                          <Typography variant="h6" color="text.secondary" fontSize="1.5rem">
                            sec
                          </Typography>
                        </Box>
                      </div>
                      <div>
                        <Chip
                          color="secondary"
                          label={`${props.showRepsDataValue ? props.showRepsDataValue + 1 : '1'}/${
                            props.repsData
                              ? props.repsData.length === 0
                                ? '1'
                                : props.repsData.length
                              : '1'
                          }`}
                          variant="outlined"
                          sx={{
                            ml: 6, // Margin left for spacing
                            marginLeft: '15px'
                          }}
                        />
                      </div>
                    </Box>
                  </Box>
                )}
              {props.type !== 'Timing' && !props.title.includes('Timing') && (
                <Chip
                  color="secondary"
                  label={`${props.showRepsDataValue ? props.showRepsDataValue + 1 : '1'}/${
                    props.repsData
                      ? props.repsData.length === 0
                        ? '1'
                        : props.repsData.length
                      : '1'
                  }`}
                  className="chipLabel"
                  variant="outlined"
                  sx={{
                    ml: 2,
                    padding: 0,
                    '& .MuiChip-label': {
                      whiteSpace: 'nowrap',
                      overflow: 'visible',
                      textOverflow: 'unset',
                      display: 'inline',
                      color: 'black'
                    }
                  }}
                />
              )}
            </Grid>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
      <Box sx={{ mt: 1 }}>{props.children}</Box>
    </BoxCont>
  );
};

TypingContainer.propTypes = {
  title: PT.string.isRequired,
  showRepsDataValue: PT.number,
  repsData: PT.array,
  type: PT.string,
  text: PT.string,
  children: PT.node
};
export default TypingContainer;
